// extracted by mini-css-extract-plugin
module.exports = {"iframe":"antd-pro-modules-goods-components-image-edit-drawer-index-iframe"};